module.exports = __webpack_public_path__ + "img/stamps.2e1f6c79.jpg";